import { useState } from 'react';

interface NavbarProps {
  scrolled: boolean;
}

export default function Navbar({ scrolled }: NavbarProps) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setMobileMenuOpen(false);
    }
  };

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-white shadow-lg' : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-24">
          <div className="flex items-center">
            <img 
              src="https://static.readdy.ai/image/b4340cdd1673521bdb15ca49ead9cb84/e91042ba6b64d325371245c365026672.png" 
              alt="LA.RA. SERVICE SRL" 
              className="h-28 w-auto"
            />
          </div>

          <div className="hidden lg:flex items-center space-x-8">
            <button
              onClick={() => scrollToSection('home')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-slate-700 hover:text-slate-900' : 'text-white hover:text-slate-200'
              }`}
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('servizi')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-slate-700 hover:text-slate-900' : 'text-white hover:text-slate-200'
              }`}
            >
              Servizi
            </button>
            <button
              onClick={() => scrollToSection('chi-siamo')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-slate-700 hover:text-slate-900' : 'text-white hover:text-slate-200'
              }`}
            >
              Chi Siamo
            </button>
            <button
              onClick={() => scrollToSection('galleria')}
              className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${
                scrolled ? 'text-slate-700 hover:text-slate-900' : 'text-white hover:text-slate-200'
              }`}
            >
              Galleria
            </button>
            <button
              onClick={() => scrollToSection('contatti')}
              className="bg-gradient-to-r from-slate-700 to-slate-900 text-white px-6 py-2.5 rounded-lg text-sm font-medium hover:from-slate-800 hover:to-slate-950 transition-all whitespace-nowrap cursor-pointer"
            >
              Contattaci
            </button>
          </div>

          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className="lg:hidden p-2 cursor-pointer"
          >
            <i className={`ri-${mobileMenuOpen ? 'close' : 'menu'}-line text-2xl ${scrolled ? 'text-slate-900' : 'text-white'}`}></i>
          </button>
        </div>
      </div>

      {mobileMenuOpen && (
        <div className="lg:hidden bg-white border-t border-slate-200">
          <div className="px-6 py-4 space-y-3">
            <button
              onClick={() => scrollToSection('home')}
              className="block w-full text-left text-slate-700 hover:text-slate-900 font-medium py-2 cursor-pointer"
            >
              Home
            </button>
            <button
              onClick={() => scrollToSection('servizi')}
              className="block w-full text-left text-slate-700 hover:text-slate-900 font-medium py-2 cursor-pointer"
            >
              Servizi
            </button>
            <button
              onClick={() => scrollToSection('chi-siamo')}
              className="block w-full text-left text-slate-700 hover:text-slate-900 font-medium py-2 cursor-pointer"
            >
              Chi Siamo
            </button>
            <button
              onClick={() => scrollToSection('galleria')}
              className="block w-full text-left text-slate-700 hover:text-slate-900 font-medium py-2 cursor-pointer"
            >
              Galleria
            </button>
            <button
              onClick={() => scrollToSection('contatti')}
              className="block w-full text-left bg-gradient-to-r from-slate-700 to-slate-900 text-white px-6 py-2.5 rounded-lg font-medium cursor-pointer"
            >
              Contattaci
            </button>
          </div>
        </div>
      )}
    </nav>
  );
}